import { useState } from 'react';

const CVDownload = ({ className, children }) => {
    const [isDownloading, setIsDownloading] = useState(false);

    const handleDownload = async (e) => {
        e.preventDefault();
        setIsDownloading(true);

        try {
            // Extract file ID from Google Drive link and create direct download URL
            const fileId = "1AcxUglEDS-wAhiVe-BmItcc-KCT0iUj2";
            const directDownloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;

            // Create a temporary link element for direct download
            const link = document.createElement('a');
            link.href = directDownloadUrl;
            link.download = 'Md_Azaharul_CV.pdf';
            link.target = '_blank';
            link.rel = 'noopener noreferrer';

            // Append to body, click, and remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Fallback: If direct download doesn't work, open the view link
            setTimeout(() => {
                window.open("https://drive.google.com/file/d/1AcxUglEDS-wAhiVe-BmItcc-KCT0iUj2/view?usp=sharing", '_blank');
            }, 2000);

        } catch (error) {
            console.error('Download failed:', error);
            // Fallback: Open Google Drive view link
            window.open("https://drive.google.com/file/d/1AcxUglEDS-wAhiVe-BmItcc-KCT0iUj2/view?usp=sharing", '_blank');
        } finally {
            setTimeout(() => setIsDownloading(false), 1500);
        }
    };

    return (
        <button
            onClick={handleDownload}
            className={className}
            disabled={isDownloading}
        >
            {isDownloading ? (
                <>
                    Downloading...
                    <span className="material-icons-round text-sm animate-spin">
                        sync
                    </span>
                </>
            ) : (
                children
            )}
        </button>
    );
};

export default CVDownload;